// frontend/packages/business-console/src/components/primitives/PageHeader.jsx
//
// The shared page-title row used by every console screen (handoff
// README section 1c): large 24/900 title, an optional meta line under
// it (status pill, subtitle, "Powered by ..."), and primary/secondary
// actions pushed to the right. Collapses to a stacked column on mobile.
//
// `meta` and `actions` are slots (nodes) so each page composes exactly
// what it needs while the title sizing + layout stay identical product-
// wide.

import React from 'react';
import { Box, Typography } from '@mui/material';

import { useTokens } from './useTokens';

export default function PageHeader({ title, meta, actions, sx }) {
  const t = useTokens();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'flex-end' },
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 1.5,
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="h1"
          sx={{
            fontSize: 24,
            fontWeight: 900,
            letterSpacing: '-0.6px',
            lineHeight: 1.1,
            color: t.text,
          }}
        >
          {title}
        </Typography>
        {meta ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mt: '6px',
              flexWrap: 'wrap',
            }}
          >
            {meta}
          </Box>
        ) : null}
      </Box>
      {actions ? (
        <Box
          sx={{ ml: { sm: 'auto' }, display: 'flex', gap: 1, flexWrap: 'wrap' }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
